import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { EsgDeleteIcon } from "assets";
import { useDeleteScorecardDataCell } from "hooks";
import { DeleteDialog } from "components/dialog/delete-dialog";

interface DeleteCellValueButtonProps {
    dataId: number | null;
}

export const DeleteCellValueButton: React.FC<DeleteCellValueButtonProps> = ({
    dataId,
}) => {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const { mutateAsync: deleteScorecardDataCell, isLoading: isDeleting } = useDeleteScorecardDataCell();

    const onDeleteIconClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        setDeleteDialogOpen(true);
    }

    const handleDeleteCell = async () => {
        if (!dataId) {
            return;
        }
        try {
            await deleteScorecardDataCell(dataId);
        } catch (error) {
            // Error handling is done in the mutation hook
        }
        setDeleteDialogOpen(false);
    }

    return (
        <>
            <Tooltip arrow placement="top" title="Delete cell">
                <IconButton
                    data-testid="delete-cell-button"
                    sx={{
                        width: "20px",
                        height: "20px",
                        padding: 0,
                        "&:hover": {
                            backgroundColor: "rgba(5, 66, 84, 0.1)",
                        },
                    }}
                    onClick={onDeleteIconClick}
                    disabled={isDeleting || !dataId}
                >
                    <EsgDeleteIcon style={{
                        width: "17px",
                        height: "13px",
                        color: !dataId ? "rgba(0, 0, 0, 0.26)" : "#EF2E14"
                    }} />
                </IconButton>
            </Tooltip>
            {deleteDialogOpen && (
                <DeleteDialog
                    isOpen={deleteDialogOpen}
                    onCancel={() => setDeleteDialogOpen(false)}
                    onDeleteClick={handleDeleteCell}
                    target="scorecardCellValue"
                    title="Delete cell values?"
                    confirmButtonDisabled={isDeleting}
                    confirmTitle={isDeleting ? "Deleting..." : "Confirm"}
                />
            )}
        </>
    );
};
